import { render, staticRenderFns } from "./VLogo.vue?vue&type=template&id=740a2036&scoped=true"
import script from "./VLogo.vue?vue&type=script&lang=js"
export * from "./VLogo.vue?vue&type=script&lang=js"
import style0 from "./VLogo.vue?vue&type=style&index=0&id=740a2036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a2036",
  null
  
)

export default component.exports